import React from 'react'
import type { AccessibilityProps } from 'react-native'
import { Button } from '~/components/button'
import * as Comp from './modal-footer.styles'

type TModalFooterProps = {
  children: React.ReactNode
  testID?: string
}

interface TButtonFooterProps extends AccessibilityProps {
  onPress?: () => void
  children: string
  testID?: string
}

export function ModalFirstButtonFooter({
  onPress,
  children,
  testID,
}: TButtonFooterProps) {
  return (
    <Button.Root
      testID={testID}
      full
      variant="brand-primary"
      size="lg"
      onPress={onPress}
    >
      <Button.Label>{children}</Button.Label>
    </Button.Root>
  )
}

export function ModalSecondButtonFooter({
  onPress,
  children,
  testID,
}: TButtonFooterProps) {
  return (
    <Button.Root
      testID={testID}
      full
      variant="neutral-secondary"
      size="lg"
      onPress={onPress}
    >
      <Button.Label>{children}</Button.Label>
    </Button.Root>
  )
}

export function ModalFooter({ children, testID }: TModalFooterProps) {
  const componentProperties = {
    testID,
  }

  const renderInternalFooterChildrens = React.Children.map(children, child => {
    if (!React.isValidElement(child)) return

    if (
      React.isValidElement(child) &&
      (child.type === ModalFirstButtonFooter ||
        child.type === ModalSecondButtonFooter)
    ) {
      return React.cloneElement(child)
    }
  })

  return (
    <Comp.Footer {...componentProperties}>
      <Comp.FooterContainer>
        {renderInternalFooterChildrens?.slice(0, 2)}
      </Comp.FooterContainer>
    </Comp.Footer>
  )
}
